import { FC } from 'react'

import { ProductIcon } from '../../../../../types/graphql/product'

import {
  Background,
  Icon,
  IconTitle,
  TextContainer,
  WhyWeLoveIconContainer,
  WhyWeLoveIconSection,
  WhyWeLoveText,
} from './styles'

export type WhyWeLoveProps = Readonly<{
  imageSrc: string | undefined
  whyWeLoveText: string
  whyWeLoveIcons: ReadonlyArray<ProductIcon> | undefined
}>

export const WhyWeLove: FC<WhyWeLoveProps> = ({ whyWeLoveText, whyWeLoveIcons }) => {
  // If we don't have text and we don't have icons... nothing to render. Move on with life.
  const iconsArePresent = whyWeLoveIcons && whyWeLoveIcons.length > 0
  if (!whyWeLoveText && !iconsArePresent) return null

  // If we have no icons, then hide the entire section when greater than or equal to md,
  // since text hides at that point, leaving us with nothing if there are no icons.
  return (
    <Background hideIfViewportGreaterThanOrEqualMd={iconsArePresent ? false : true}>
      <TextContainer>
        {/* Only render text on small viewports. It renders elsewhere on large viewports. */}
        <WhyWeLoveText asTag='p' hideIfViewportGreaterThanOrEqualMd data-testid='why-we-love-text'>
          {whyWeLoveText}
        </WhyWeLoveText>

        {/* Render icons here for all viewports. */}
        {iconsArePresent && (
          <WhyWeLoveIconSection data-testid='why-we-love-icons'>
            {whyWeLoveIcons.map((icon, index) => (
              <WhyWeLoveIconContainer
                key={`${index}-${icon.label}`}
                wrapTwo={whyWeLoveIcons.length === 4}
              >
                <Icon
                  src={icon.image}
                  alt={icon.label}
                  widths={{ unit: 'px', sm: 48, md: 38 }}
                  aspectRatios={{ sm: 1, md: 1 }}
                  loading='default'
                  transparentBackground={true}
                />
                <IconTitle textAlign='center'>{icon.title}</IconTitle>
              </WhyWeLoveIconContainer>
            ))}
          </WhyWeLoveIconSection>
        )}
      </TextContainer>
    </Background>
  )
}

export default WhyWeLove
